"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoadingIndicator = void 0;
var React = __importStar(require("react"));
var Flex_1 = require("../Flex");
var View_1 = require("../View");
var VisuallyHidden_1 = require("../VisuallyHidden");
var icons_1 = require("../icons");
var theme_1 = require("../theme");
var PageLoadingIndicator = function (_a) {
    var _b = _a.accessibilityLabel, accessibilityLabel = _b === void 0 ? 'Loading CircleCI experience' : _b, _c = _a.containerHeight, containerHeight = _c === void 0 ? '100%' : _c;
    return (React.createElement(Flex_1.Flex, { justify: "center", align: "center", height: containerHeight, "aria-live": "assertive" },
        React.createElement(View_1.View, { padding: "space8" },
            React.createElement(icons_1.CircleLogoIcon, null)),
        React.createElement(View_1.View, { color: "n900", fontSize: "fontsize16", fontWeight: "bold", paddingRight: "space16" }, "Loading"),
        React.createElement(View_1.View, { borderLeft: "".concat(theme_1.theme.borderWidths.regular, " solid ").concat(theme_1.theme.colors.n70), paddingLeft: "space8", role: "status" },
            React.createElement(icons_1.LoadingIcon, null),
            React.createElement(VisuallyHidden_1.VisuallyHidden, null, accessibilityLabel))));
};
exports.PageLoadingIndicator = PageLoadingIndicator;
//# sourceMappingURL=index.js.map